import { BodyText } from '@/utils/global-fonts';
import styled from 'styled-components';

const NoLabel = styled.div`
  height: 18px;
  margin-top: 12px;
`;

const Label = styled.label`
  color: ${({ $textColor }) => $textColor};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 12px;
`;

const FieldContainer = styled.div`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  display: flex;
  outline: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-radius: 4px;
  border: none;
  height: 48px;
  align-items: center;
  cursor: pointer;

  &:focus-within {
    outline: 1px solid ${({ theme }) => theme.COLOR_BLACK};
  }
`;
const RoundColor = styled.span`
  border-radius: 50%;
  display: inline-block;
  height: 20px;
  width: 20px;
  background-color: ${({ $color }) => $color};
  margin: 0 8px 0 14px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;

const RenderOnTop = styled.div`
  z-index: 1;
`;

const ColorText = styled(BodyText)`
  /* margin: 10px; */
`;

const StyledInput = {
  Label,
  FieldContainer,
  NoLabel,
  RoundColor,
  RenderOnTop,
  ColorText,
};

export default StyledInput;
